import { queryOptions } from "@tanstack/react-query";
import { GET_FUKADA_LIVE_RECORDING } from "~/constants/apiEndpoints";
import { apiClient } from "~/lib/apiClient";
import { getCurrentApplicationId } from "~/lib/applicationId";
import { queryKeys } from "~/lib/queryKeys";

export type FukadaLiveRecordingClip = {
  version: number;
  videoUrl: string;
};

type GetFukadaLiveRecordingResponseItem = {
  version: number;
  video_url: string;
};

/**
 * 深田えいみの過去配信クリップ一覧（プロフィール画像の動画化用。CAMPAIGN_USER_ID 専用）。
 * feature `profile` からのみ参照するが、深田えいみ関連の共有クエリは lib/queryOptions に
 * 集約する既存方針（fukadaCampaignSchedule 等）に倣う。
 */
export const fukadaLiveRecordingQueryOptions = queryOptions({
  queryKey: queryKeys.fukadaCampaign.liveRecording(),
  queryFn: async (): Promise<FukadaLiveRecordingClip[]> => {
    const res = await apiClient<GetFukadaLiveRecordingResponseItem[]>(
      GET_FUKADA_LIVE_RECORDING,
      { application_id: getCurrentApplicationId() },
    );
    return (res ?? []).map((item) => ({
      version: item.version,
      videoUrl: item.video_url,
    }));
  },
});
